import React, { FC } from 'react';
import { FailedRecordsList } from './components/FailedRecordsList/FailedRecordsList';
import { IFailedRecord } from './types';
import { RetryPollingButton } from './components/RetryPollingButton';

interface IReportProps {
  reportTitle: string;
  isTimedOut: boolean;
  onRetry: () => void;
  headerClassName?: string;
  'data-id'?: string;
  errors: IFailedRecord[];
  children: React.ReactNode;
}

export const Report: FC<IReportProps> = ({
  reportTitle,
  isTimedOut,
  onRetry,
  headerClassName,
  'data-id': dataId,
  errors = [],
  children,
}) => {
  return (
    <div data-id={dataId} className="flex flex-col p-4 bg-white overflow-hidden w-1/2 rounded-lg">
      <h6
        className={`${headerClassName} text-lg font-semibold text-white py-2 px-4 rounded-md 
        text-center mb-4 bg-green-ncs`}
      >
        {reportTitle}
      </h6>

      <ul className="mb-2">{children}</ul>

      <RetryPollingButton title="Continue" onClick={onRetry} disabled={!isTimedOut} />
      <FailedRecordsList data-id="list-of-errors" failedRecords={errors} />
    </div>
  );
};
